import { useBookitoSettings } from '@carlito/api';
import { SupportedLanguages, useListLocalizedEvents } from '@carlito/bookito-client';
import { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import BookitoEventDetail from '../BookitoEventDetail';
import Modal from '../Modal';
import ModalLoader from './ModalLoader';

export type BookitoEventModalProps = {
  eventId: string;
  language?: SupportedLanguages;
  authId: string;
  onCloseModal: () => void;
  openModal: boolean;
};

const BOOKABLE_DAYS_IN_ADVANCE = 90;
const defaultToDate = new Date();

defaultToDate.setDate(defaultToDate.getDate() + BOOKABLE_DAYS_IN_ADVANCE);

function BookitoEventModal(props: BookitoEventModalProps) {
  const { i18n } = useTranslation();
  useLayoutEffect(() => {
    if (props?.language) {
      i18n.changeLanguage(props?.language);
    }
  }, [props?.language, i18n]);

  const bookitoSettings = useBookitoSettings({
    hotelId: props.authId,
  });

  const { data, isLoading } = useListLocalizedEvents(
    {
      authId: props.authId,
      id: props.eventId,
      toDate: defaultToDate.toISOString(),
      daysBookableInAdvance: (
        bookitoSettings.bookitoSettings?.daysBookableInAdvance ?? 90
      ).toString(),
    },
    props.openModal && Boolean(bookitoSettings.bookitoSettings)
  );

  const event = data?.events[0];

  const firstAvailableDate = data?.availableOnDates?.[0]
    ? new Date(data?.availableOnDates?.[0])
    : new Date();

  return props.openModal ? (
    <Modal onCloseModal={props.onCloseModal}>
      {isLoading && <ModalLoader />}
      {data && event && (
        <BookitoEventDetail
          event={event}
          date={firstAvailableDate}
          authId={props.authId}
          availableOnDates={data.availableOnDates || []}
          isModalView={true}
        />
      )}
    </Modal>
  ) : null;
}

export default BookitoEventModal;
